module.exports = __webpack_public_path__ + "static/media/kalp.d6cd4fb2.png";